import cn from 'classnames';
import Hamburger from '@components/hamburger';
import logoutSvg from '@assets/svg/logout.svg';
import Button from '@components/button';
import useReduxState from '@hooks/useReduxState';
import useUserLogout from '@hooks/useUserLogout';

import styles from './app-head.module.scss';
import { useNavigate } from 'react-router-dom';
import { formatThousandNumber } from '@utils/utils';
import UserBalance from './components/balance';

export interface IAppHeadProps {
    title?: string;
    connected: boolean;
    connecting: boolean;
    connectWallet: () => void;
    isNavigationMenuVisible: boolean;
    toggleNavigationMenuVisibilityInMobile: () => void;
    openDepositModal: () => void;
    openWithdrawalModal: () => void;
}

const AppHead = ({
    title = '',
    connected,
    connecting,
    connectWallet,
    isNavigationMenuVisible,
    toggleNavigationMenuVisibilityInMobile,
    openDepositModal,
    openWithdrawalModal,
}: IAppHeadProps): JSX.Element => {
    const [{ chat, userData: user }] = useReduxState((state) => state);
    const [logoutUser] = useUserLogout();
    const navigate = useNavigate();

    /* ClassNames */

    const titleClasses: string = cn(styles.title__name, {
        [styles['chat-visible']]: !chat.collapsed,
    });

    return (
        <header className={styles.header}>
            <div className={styles.title}>
                <Hamburger
                    className={styles.hamburger}
                    isActive={isNavigationMenuVisible}
                    onClick={toggleNavigationMenuVisibilityInMobile}
                />
                <h1 className={titleClasses}>{title}</h1>
            </div>

            {/* Header - NOT Logged in */}
            {user.username === '' && (
                <div className={styles.connection}>
                    <button className={styles.connect} onClick={connectWallet}>
                        {!connected ? 'Connect Wallet' : ''}
                        {connecting ? 'Connecting' : ''}
                        {connected ? 'Connected' : ''}
                    </button>
                </div>
            )}

            {/* Header - Logged in */}
            {user.username !== '' && (
                <>
                    <div className={styles.data}>
                        <UserBalance styles={styles} />
                        <div className={styles.data__info}>
                            <button
                                className={styles.depositButton}
                                onClick={openDepositModal}
                            >
                                Deposit
                            </button>

                            <Button
                                className={cn(
                                    styles.withdrawButton,
                                    styles.button_style,
                                )}
                                color="dark-lighten"
                                onClick={openWithdrawalModal}
                            >
                                Withdraw
                            </Button>
                        </div>

                        <div
                            className={styles.account}
                            onClick={() => {
                                navigate(`/user/${user.uid}`);
                            }}
                        >
                            <div className={styles.details}>
                                <figure className={styles.image}>
                                    <img
                                        src="https://www.foxopera.house/static/media/10.84bcf4b2.png"
                                        alt="avatar"
                                    />
                                </figure>
                                <div className={styles.container}>
                                    <span className={styles.circle} />
                                    <div className={styles.name}>
                                        {user.username}
                                    </div>
                                    <div className={styles.balance}>
                                        <span className={styles.icon} />
                                        <span className={styles.value}>
                                            {formatThousandNumber(user.balance)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={styles.buttons}>
                            <button
                                className={styles.iconButton}
                                onClick={logoutUser}
                            >
                                <img src={logoutSvg} alt="" />
                            </button>
                        </div>
                    </div>
                </>
            )}
        </header>
    );
};

export default AppHead;
